//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            dropAreas: [{
                position: 0,
                connectedPositions: [1, 3]
            }, {
                position: 1,
                connectedPositions: [0, 2, 4]
            }, {
                position: 2,
                connectedPositions: [1, 5]
            }, {
                position: 3,
                connectedPositions: [0, 4, 6]
            }, {
                position: 4,
                connectedPositions: [1, 3, 5, 7]
            }, {
                position: 5,
                connectedPositions: [2, 4, 8]
            }, {
                position: 6,
                connectedPositions: [3, 7]
            }, {
                position: 7,
                connectedPositions: [4, 6, 8]
            }, {
                position: 8,
                connectedPositions: [5, 7]
            }],
            puzzles: [{
                id: 0,
                currentPosition: 0,
                image: '/images/game/w3d1/puzzle_0.png'
            }, {
                id: 1,
                currentPosition: 8,
                image: '/images/game/w3d1/puzzle_1.png'
            }, {
                id: 2,
                currentPosition: 4,
                image: '/images/game/w3d1/puzzle_2.png'
            }, {
                id: 4,
                currentPosition: 6,
                image: '/images/game/w3d1/puzzle_4.png'
            }, {
                id: 5,
                currentPosition: 3,
                image: '/images/game/w3d1/puzzle_5.png'
            }, {
                id: 6,
                currentPosition: 1,
                image: '/images/game/w3d1/puzzle_6.png'
            }, {
                id: 7,
                currentPosition: 5,
                image: '/images/game/w3d1/puzzle_7.png'
            }, {
                id: 8,
                currentPosition: 2,
                image: '/images/game/w3d1/puzzle_8.png'
            }],
            // solutions mapping puzzleID => correctPosition
            solutions: [{
                0: 3,
                2: 7,
                5: 5,
                7: 6,
                8: 8
            }, {
                0: 3,
                2: 5,
                5: 4,
                7: 6,
                8: 7
            }, {
                0: 4,
                2: 3,
                5: 5,
                7: 7,
                8: 8
            }, {
                0: 2,
                2: 1,
                5: 0,
                7: 5,
                8: 3
            }, {
                0: 1,
                2: 5,
                5: 0,
                7: 4,
                8: 3
            }, {
                0: 2,
                2: 3,
                5: 1,
                7: 5,
                8: 4
            }]
        };
    },

    computed: {
        nickname () {
            return this.$store.getters.nickname;
        },
        puzzleSolved () {
            return this.solutions.some(solution => {
                return !Object.entries(solution).some(([id, correctPosition]) => {
                    let puzzle = this.puzzles.find(puzzle => puzzle.id === parseInt(id));
                    return puzzle !== undefined && puzzle.currentPosition !== correctPosition;
                });
            });
        },
        result () {
            return {
                stars: this.puzzleSolved ? 5 : 0,
                correct: this.puzzleSolved ? 1 : 0,
                wrong: this.puzzleSolved ? 0 : 1
            };
        }
    },

    created () {
        this.dropAreas.forEach((dropArea, index) => {
            this.$set(dropArea, 'x', 503 + (index % 3 * 152));
            this.$set(dropArea, 'y', 227 + (Math.floor(index / 3) * 152));
        });
    },

    methods: {
        getPuzzleImage (dropArea) {
            let puzzle = this.puzzles.find(puzzle => puzzle.currentPosition === dropArea.position);

            return puzzle && puzzle.image ? puzzle.image : '';
        },
        setPuzzlePosition (dropArea) {
            let puzzle = this.puzzles.find(puzzle => puzzle.currentPosition === dropArea.position);

            dropArea.connectedPositions.forEach(connectedPosition => {
                let connectedPuzzle = this.puzzles.find(puzzle => puzzle.currentPosition === connectedPosition);
                if (connectedPuzzle === undefined) {
                    puzzle.currentPosition = connectedPosition;
                }
            });
        }
    }
};
